// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"1cd9ee34","570":"7988a73f"}[chunkId] + ".chunk.js";
};